import { useContext } from "react";
import { VacancyPageContext } from "../contexts/vacancyPageContext";

const useVacancyPageContext = () => useContext(VacancyPageContext);

export { useVacancyPageContext };
